import { rmlApi } from "./setup";

const getToken = async () => {
  const res = await rmlApi.post("/api/Token/Token");
  return res;
};

export const tokenServices = { getToken };
